module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av350-384f34a742a3dbb478ffc6b505019ac8.jpg";